import React from "react";

const MobileUpdateButton = props => {
  return (
    <button
      className="btn btn-danger btn-lg"
      value={"update"}
      onClick={() => {
        props.onClick();
      }}
    >
      {props.title.text}
    </button>
  );
};

export default MobileUpdateButton;
